import { makeStyles } from '@mui/styles'
import { StatusColorInputBase } from './types'

export const useStyles = (
  status: StatusColorInputBase,
  backgroundColor?: string
) =>
  makeStyles(() => ({
    root: {
      marginTop: '10px',
      height: '40px',
      padding: '10px',
      textAlign: 'center',
      width: '99%',
      backgroundColor: backgroundColor // Usar el parámetro backgroundColor
    },
    status: {
      border: `2px solid ${getColorStatus(status)}`,
      color: `${getColorStatus(status)}`,
      borderRadius: '5px'
    },
    centerText: {
      textAlign: 'center',
      fontWeight: 'bold'
    },
    dropDownList: {
      marginTop: '10px',
      width: '475px'
    }
  }))

export const getColorStatus = (status: StatusColorInputBase) => {
  const colors = {
    error: 'red',
    success: 'green',
    default: 'gray'
  }

  return colors[`${status}`]
}
